import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux';
import { eventNameConstants, interactionTypeConstants, trackEvent } from 'dibs-tracking';
import headerReducer from '../reducers/headerReducer.ts';
import { actionCreators } from '../actions/index.ts';

const useImageSearchSelector: TypedUseSelectorHook<{ header: ReturnType<typeof headerReducer> }> =
    useSelector;
export const useImageSearch = (): {
    isImageSearchModalOpen: boolean;
    openImageSearchModal: () => void;
    closeImageSearchModal: () => void;
} => {
    const dispatch = useDispatch();
    const isImageSearchModalOpen = useImageSearchSelector(
        state => !!state.header.isImageSearchModalOpen
    );

    return {
        isImageSearchModalOpen,
        openImageSearchModal: () => {
            dispatch(actionCreators.setImageSearchModalOpen());
            trackEvent({
                eventName: eventNameConstants.EVENT_NAVIGATION,
                interaction_type: interactionTypeConstants.INTERACTION_TYPE_GLOBAL_NAV,
                step_interaction_name: 'image search - click icon',
            });
        },
        closeImageSearchModal: () => {
            dispatch(actionCreators.setImageSearchModalClosed());
        },
    };
};
